import type { ReactNode } from 'react'
import Logo from '@claritio/frontend/components/Logo'
import AuthBrandPanel from '@claritio/frontend/components/AuthBrandPanel'

interface AuthLayoutProps {
  title: string
  subtitle?: ReactNode
  /** Brand column, desktop only. Defaults to AuthBrandPanel; pass null for none. */
  aside?: ReactNode
  /** Pinned to the bottom of the form column. */
  footer?: ReactNode
  children: ReactNode
}

// Every sign-in, sign-up and recovery page: a white form column without a box,
// the title in Archivo Light, and the brand column beside it on desktop.
export default function AuthLayout({ title, subtitle, aside = <AuthBrandPanel />, footer, children }: AuthLayoutProps) {
  return (
    <div className="bg-content lg:grid lg:min-h-screen lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
      <div className="flex min-h-screen flex-col px-5">
        <div className="m-auto w-full max-w-sm py-10">
          <div className="mb-8 flex flex-col gap-6">
            <Logo size="lg" />
            <div className="flex flex-col gap-1.5">
              <h1 className="font-heading text-display-sm text-foreground">{title}</h1>
              {subtitle && <p className="text-muted-foreground">{subtitle}</p>}
            </div>
          </div>
          {children}
        </div>
        {footer && <div className="mx-auto w-full max-w-sm pb-6">{footer}</div>}
      </div>
      {aside && <aside className="hidden lg:block">{aside}</aside>}
    </div>
  )
}
